import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.$wrapper = this.$('wrapper')[0]
    this.$bubbles = this.$('bubble')
    this.$svg = window.innerWidth < 900 ? this.$('svg-mobile')[0] : this.$('svg')[0]
  }

  init() {
    this.move()
    this.scale()
    this.scroll()

    window.addEventListener('resize', this.scale.bind(this))
  }

  scale() {
    const svg = this.$svg
    const clipPath = svg.querySelector('clipPath')

    // Get the window width and height
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    // Calculate the target width based on 65% of the window width
    const targetWidth = windowWidth * 0.65

    // Get the bounding box of the clipPath element
    const bbox = clipPath.getBBox()

    // Calculate the scale factors for width and height
    const scaleX = targetWidth / bbox.width
    const scaleY = windowWidth < 900 ? (windowHeight * 0.65) / bbox.height : windowHeight / bbox.height
    const scale = Math.min(scaleX, scaleY)

    clipPath.style.transform = `scale(${scale})`
  }

  move() {
    // const wrapper = document.querySelector('[data-404-wrapper]')

    this.$bubbles.forEach((bubble) => {
      const wrapperRect = this.$wrapper.getBoundingClientRect()

      const position = {
        x: wrapperRect.left + wrapperRect.width * 0.2,
        y: wrapperRect.top + wrapperRect.height * 0.2,
      }

      this.$wrapper.style.setProperty('--wrapper-x-offset', `${wrapperRect.left}px`)
      this.$wrapper.style.setProperty('--wrapper-y-offset', `${wrapperRect.top}px`)

      let angle = Math.random() * 360

      /* console.log(angle) */

      gsap.set(bubble, { autoAlpha: 1, x: position.x, y: position.y })
      bubble.classList.remove('hidden')

      const animation = gsap.to(bubble, {
        duration: 0.5,
        repeat: -1,
        yoyo: true,
        onUpdate() {
          position.x += Math.cos((angle * Math.PI) / 180)
          position.y += Math.sin((angle * Math.PI) / 180)
          gsap.set(bubble, { x: position.x, y: position.y })

          const bubbleRect = bubble.getBoundingClientRect()

          if (bubbleRect.left <= wrapperRect.left
          || bubbleRect.right >= wrapperRect.left + wrapperRect.width) {
            angle = 180 - angle
          }
          if (bubbleRect.top <= wrapperRect.top
          || bubbleRect.bottom >= wrapperRect.top + wrapperRect.height) {
            angle = 360 - angle
          }
        },
      })
    })
  }

  scroll() {
    const animation = gsap.to(this.$wrapper, { autoAlpha: 0, paused: true })

    ScrollTrigger.create({
      trigger: this.el,
      start: 'bottom 90%',
      onEnter() {
        animation.play()
      },
      onLeaveBack() {
        animation.reverse()
      },
    })
  }
}
